
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#007fff","d":"M0 0h800v600H0z"}}),_c('path',{attrs:{"d":"M36 120h84l26-84 26 84h84l-68 52 26 84-68-52-68 52 26-84-68-52zM750 0L0 450v150h50l750-450V0h-50","fill":"#f7d618"}}),_c('path',{attrs:{"d":"M800 0L0 480v120l800-480V0","fill":"#ce1021"}})])
          )
        }
      }
    